{ "id": "transposition", "name": "Transposition", "icon": "icons/spells/transposition", "description": "Échange sa place avec l'ennemi le plus proche de la visée.", "cooldown": 7, "effects": [ { "type": "swap", "maxRange": 400 } ] }
